/**
 * @generated SignedSource<<7482429cb1b3eed69733b1d25dbf2b48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type PagesListSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type PagesListSortMutation$data = {
  readonly updatePagePositions: boolean | null;
};
export type PagesListSortMutation = {
  response: PagesListSortMutation$data;
  variables: PagesListSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updatePagePositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PagesListSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PagesListSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "92fb58e21551791d18c22f00d024f9d2",
    "id": null,
    "metadata": {},
    "name": "PagesListSortMutation",
    "operationKind": "mutation",
    "text": "mutation PagesListSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updatePagePositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "f616ad0da8a47c41c3f3a9250f9049c5";

export default node;
